import { accordionTokens } from './accordion.tokens';
import { avatarTokens } from './avatar.tokens';
import { badgeTokens } from './badge.tokens';
import { bannerTokens } from './banner.tokens';
import { carouselTokens } from './carousel.tokens';
import { buttongroupTokens } from './buttongroup.tokens';
import { buttonTokens } from './button.tokens';
import { calendarTokens } from './calendar.tokens';
import { cardTokens } from './card.tokens';
import { checkboxTokens } from './checkbox.tokens';
import { chipTokens } from './chip.tokens';
import { confirmpopupTokens } from './confirmpopup.tokens';
import { dialogTokens } from './dialog.tokens';
import { dividerTokens } from './divider.tokens';
import { globalloaderTokens } from './globalloader.tokens';
import { iconfieldTokens } from './iconfield.tokens';
import { inlineeditTokens } from './inlineedit.tokens';
import { inputTokens } from './input.tokens';
import { inputnumberTokens } from './inputnumber.tokens';
import { linkTokens } from './link.tokens';
import { listboxTokens } from './listbox.tokens';
import { menuTokens } from './menu.tokens';
import { messagesTokens } from './messages.tokens';
import { multiselectTokens } from './multiselect.tokens';
import { panelTokens } from './panel.tokens';
import { pillTokens } from './pill.tokens';
import { popoverTokens } from './popover.tokens';
import { radiobuttonTokens } from './radiobutton.tokens';
import { selectTokens } from './select.tokens';
import { skeletonTokens } from './skeleton.tokens';
import { sliderTokens } from './slider.tokens';
import { switchTokens } from './switch.tokens';
import { tableTokens } from './table.tokens';
import { tabsTokens } from './tabs.tokens';
import { tagTokens } from './tag.tokens';
import { textfieldTokens } from './textfield.tokens';
import { timelineTokens } from './timeline.tokens';
import { toastTokens } from './toast.tokens';
import { tooltipTokens } from './tooltip.tokens';

/**
 * All component tokens combined for use in definePreset
 */
export const componentTokens = {
  ...accordionTokens,
  ...avatarTokens,
  ...badgeTokens,
  ...bannerTokens,
  ...carouselTokens,
  ...buttongroupTokens,
  ...buttonTokens,
  ...calendarTokens,
  ...cardTokens,
  ...checkboxTokens,
  ...chipTokens,
  ...confirmpopupTokens,
  ...dialogTokens,
  ...dividerTokens,
  ...globalloaderTokens,
  ...iconfieldTokens,
  ...inlineeditTokens,
  ...inputTokens,
  ...inputnumberTokens,
  ...linkTokens,
  ...listboxTokens,
  ...menuTokens,
  ...messagesTokens,
  ...multiselectTokens,
  ...panelTokens,
  ...pillTokens,
  ...popoverTokens,
  ...radiobuttonTokens,
  ...selectTokens,
  ...skeletonTokens,
  ...sliderTokens,
  ...switchTokens,
  ...tableTokens,
  ...tabsTokens,
  ...tagTokens,
  ...textfieldTokens,
  ...timelineTokens,
  ...toastTokens,
  ...tooltipTokens
};

export type ComponentTokens = typeof componentTokens;
